import { render, staticRenderFns } from "./InfoItAndTechnology.vue?vue&type=template&id=36e4b70a&scoped=true"
import script from "./InfoItAndTechnology.vue?vue&type=script&lang=js"
export * from "./InfoItAndTechnology.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e4b70a",
  null
  
)

export default component.exports